// extracted by mini-css-extract-plugin
export default {"skeleton-bar":"DeviceCardSkeleton_skeleton-bar__YcTEf","shimmer":"DeviceCardSkeleton_shimmer__Cb+hR"};